const CARD_BUILDER = "card_builder";
const BOOK_BUILDER = "book_builder";
const PLAYMAT_BUILDER = "playmat_builder";

export { CARD_BUILDER, BOOK_BUILDER, PLAYMAT_BUILDER };
